﻿import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export function CustomIcon(
    {
        iconName = '',
        className = ''
    }
) {
    const iconPrefix = 'custom-icon-';

    return (
        <Fragment>
            <i className={classNames(`${iconPrefix}${iconName}`, className)}></i>
        </Fragment>
    );
}

CustomIcon.propTypes = {
    iconName: PropTypes.string,
    className: PropTypes.string
};